import AgoraRTC from 'agora-rtc-sdk-ng'
import { LeiaRTC, RemoteStreamType } from 'leia-rtc-web-sdk'
import Global from '@/global'
import i18n from '@/i18n'

// 全局只能有一个rtc实例
let client

function throttle(func, delay) {
  let lastCall = 0
  let timeoutId = null
  let lastArgs = null
  return function() {
    const now = new Date().getTime()
    lastArgs = arguments
    if (now - lastCall < delay) {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        lastCall = now
        func.apply(this, lastArgs)
      }, delay)
    } else {
      lastCall = now
      func.apply(this, arguments)
    }
  }
}

export default {
  listenerChangeVideoStream: throttle((type, client, { localUser, context, bigVideoUser }) => {
    let QUALITY
    if (type === Global.MediaSource.MediaSAgora) {
      QUALITY = Global.AGORA_STREAM_QUALITY
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      QUALITY = Global.LEIARTC_STREAM_QUALITY
    }
    const { HIGHT_QUALITY, LOW_QUALITY } = QUALITY

    const allVideoUsers = client.remoteUsers.filter(item => item.hasVideo)

    const STREAMQUALITY = (allVideoUsers.length > (localUser.cameraOn ? 3 : 4)) ? LOW_QUALITY : HIGHT_QUALITY
    context.commit('toggleSessionMembersOfStreamType', STREAMQUALITY)

    if (bigVideoUser) {
      // 有大屏
      const isNotBigOfVideoUsers = allVideoUsers.filter(item => String(bigVideoUser.id) !== String(item.uid))
      isNotBigOfVideoUsers.forEach(item => client.setRemoteVideoStreamType(item.uid, LOW_QUALITY).catch(err => console.error(`${item.uid} ${err.message}`)))
    } else {
      // 无大屏
      allVideoUsers.forEach(item => client.setRemoteVideoStreamType(item.uid, STREAMQUALITY).catch(err => console.error(`${item.uid} ${err.message}`)))
    }
  }, 500),
  toggleRemoteVideoStreamType (type, client, { bigVideoUser, isLocal, bigVideo, sessionMembers }) {
    let QUALITY
    if (type === Global.MediaSource.MediaSAgora) {
      QUALITY = Global.AGORA_STREAM_QUALITY
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      QUALITY = Global.LEIARTC_STREAM_QUALITY
    }
    const { HIGHT_QUALITY, LOW_QUALITY } = QUALITY

    if (bigVideo) {
      if (!isLocal) {
        client.setRemoteVideoStreamType(+bigVideoUser.id, HIGHT_QUALITY).catch(err => console.error(`${+bigVideoUser.id} ${err.message}`))
      }
      client.remoteUsers
        .filter(item => item.hasVideo && +bigVideoUser.id !== +item.uid)
        .forEach(item => client.setRemoteVideoStreamType(item.uid, LOW_QUALITY).catch(err => console.error(`${item.uid} ${err.message}`)))
    } else {
      sessionMembers
        .filter(item => item.cameraOn)
        .forEach(item => item.rtcUser.uid && client.setRemoteVideoStreamType(+item.rtcUser.uid, item.streamType).catch(err => console.error(`${item.uid} ${err.message}`)))
    }
  },
  initEngine(type, address){
    if (type === Global.MediaSource.MediaSAgora) {
      // 声网日志设为warning级别
      AgoraRTC.setLogLevel(2)
      AgoraRTC.enableLogUpload()
    } else if (type === Global.MediaSource.MediaSLeiartc){
      LeiaRTC.setLoginServer(address)
    }
  },
  getMicrophones () {
    return AgoraRTC.getMicrophones().then(devices => {
      console.log('检测音频输入设备：', devices)
      return devices
    })
  },

  switchMicrophone (type, audioTrack) {
    let rtc
    if (type === Global.MediaSource.MediaSAgora) {
      rtc = AgoraRTC
    } else if (type === Global.MediaSource.MediaSLeiartc){
      rtc = LeiaRTC
    }

    if (audioTrack) {
      console.log('存在音频轨道，开始检测麦克风设备变动')
      rtc.onMicrophoneChanged = async (changedDevice) => {
        if (!audioTrack) return
        console.log('检测到设备变动：', changedDevice)
        console.log('之前音频使用的设备：', audioTrack.getTrackLabel())
        // 插入设备时，切换到新插入的设备。
        if (changedDevice.state === 'ACTIVE') {
          audioTrack.setDevice(changedDevice.device.deviceId)
          // 拔出设备为当前设备时，切换到一个已有的设备。
        } else {
          const oldMicrophones = await rtc.getMicrophones()
          console.log('自动切换为系统首个音频输入设备：', oldMicrophones)
          oldMicrophones[0] && audioTrack.setDevice(oldMicrophones[0].deviceId)
        }
      }
    } else {
      console.log('停止检测麦克风设备变动')
      rtc.onMicrophoneChanged = () => {}
    }
  },

  createRtcClient (type, params, address) {
    if (client) {
      client.leave()
    }
    if (type !== Global.MediaSource.MediaSAgora && type !== Global.MediaSource.MediaSLeiartc) {
      console.warn('目前web端只接受声网RTC和LeiaRTC通讯')
      return
    }

    let rtc
    if (type === Global.MediaSource.MediaSAgora) {
      rtc = AgoraRTC
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      rtc = LeiaRTC
      rtc.RemoteStreamType = RemoteStreamType
    }

    this.initEngine(type, address)

    client = rtc.createClient(params)
    client.enableDualStream().then(() => {
      console.log('成功开启多流成功')
    }).catch((err) => {
      console.error('成功开启多流失败', err.message)
    })

    client.setRemoteDefaultVideoStreamType(rtc.RemoteStreamType.HIGH_STREAM).then(() => {
      console.log('设置订阅远端视频为大流')
    }).catch((err) => {
      console.error('设置订阅远端视频为大流失败', err.message)
    })

    return client
  },
  bindNetworkQuality (type, client, callback) {
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      client.on('network-quality', s => callback(s))
    }
  },

  bindRtcEvent (type, client, context) {
    if (!client) return
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      client.on('user-published', (user, mediaType) => {
        console.log(`用户${user.uid}发布了${mediaType === 'video' ? '视频流' : '音频流'}`)

        if (mediaType === 'video') {
          this.listenerChangeVideoStream(type, context.state.sessionMediaClient, {
            bigVideoUser: context.getters.bigVideoUser,
            localScreenSharingOn: context.getters.localScreenSharingOn,
            localUser: context.getters.localUser,
            context
          })
        }

        client.subscribe(user, mediaType).then(() => {
          const targetUser = context.state.sessionMembers.find(member => +member.id === +user.uid)
          targetUser.rtcUser = user
          if (mediaType === 'video') {
            if (targetUser.cameraOn){
              if (targetUser.isPlayBigVideo){
                user.videoTrack.play('big-video-player', Global.AGORA_VIDEO_CONFIG)
              } else {
                user.videoTrack.play(`video-player-${user.uid}`, Global.AGORA_VIDEO_CONFIG)
              }
            }
          } else if (mediaType === 'audio') {
            if (!context.getters.localUser.speakerOn){
              user.audioTrack.setVolume(0)
            } else {
              user.audioTrack.setVolume(100)
            }
            user.audioTrack.play()
          }
        })
      })
      client.on('user-unpublished', (user, mediaType) => {
        console.log(`用户${user.uid}停止发布${mediaType === 'video' ? '视频流' : '音频流'}`)

        if (mediaType === 'video') {
          this.listenerChangeVideoStream(type, context.state.sessionMediaClient, {
            bigVideoUser: context.getters.bigVideoUser,
            localScreenSharingOn: context.getters.localScreenSharingOn,
            localUser: context.getters.localUser,
            context
          })
        }
      })
    }
  },

  joinRoom (type, client, params) {
    if (!client) return Promise.reject(new Error(i18n.tc('rtc.RTCClientNotExist')))
    if (type === Global.MediaSource.MediaSAgora) {
      return client.join(params.appId, params.channel, params.token, +params.uid)
    } else if (type === Global.MediaSource.MediaSLeiartc){
      return client.join(params.appId, params.channel, params.appKey, +params.uid)
    } else {
      return Promise.reject(new Error(i18n.tc('rtc.WebOnlySupportRTC')))
    }
  },

  leaveRoom (type, client, user = {}) {
    if (!client) return Promise.reject(new Error(i18n.tc('rtc.RTCClientNotExist')))
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      // 关闭所有远程的音视频轨道
      console.log('关闭所有远程的音视频轨道')
      client.remoteUsers.forEach(u => {
        u.videoTrack && u.videoTrack.stop()
        u.audioTrack && u.audioTrack.stop()
      })
      // 取消所有监听事件
      client.removeAllListeners()
      user.videoTrack && user.videoTrack.close()
      user.audioTrack && user.audioTrack.close()
      // 关闭所有本地的音视频轨道
      console.log('关闭所有本地的音视频轨道')
      client.localTracks.forEach(t => {
        t.close()
      })
      this.switchMicrophone(type)
      return client.leave()
    } else return Promise.reject(new Error(i18n.tc('rtc.WebOnlySupportRTC')))
  },

  toggleLocalAudio (type, client, on, user) {
    if (!client) return Promise.reject(new Error(i18n.tc('rtc.RTCClientNotExist')))
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc){
      // 初次开启麦克风需要获取轨道
      if (!user.audioTrack && on){
        return this.publishLocalAudio(type, client, user).then(_ => {
          this.switchMicrophone(type, user.audioTrack)
        })
      } else {
        return this.toggleMute(user.audioTrack, on)
      }
    } else return Promise.reject(new Error(i18n.tc('rtc.WebOnlySupportRTC')))
  },

  async publishLocalAudio (type, client, user) {
    let rtc
    if (type === Global.MediaSource.MediaSAgora) {
      rtc = AgoraRTC
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      rtc = LeiaRTC
    }

    try {
      user.audioTrack = await rtc.createMicrophoneAudioTrack()
      await client.publish(user.audioTrack)
    } catch (err) {
      console.error('发布本地音频失败', err)
      return Promise.reject()
    }
  },

  toggleLocalVideo (type, client, on, user, id, config) {
    if (!client) return Promise.reject(new Error(i18n.tc('rtc.RTCClientNotExist')))
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      if (on) {
        return this.publishLocalVideo(type, client, user, id, config)
      } else {
        return this.unPublishLocalMedia(client, user.videoTrack).then(() => {
          user.videoTrack = null
        })
      }
    } else return Promise.reject(new Error(i18n.tc('rtc.WebOnlySupportRTC')))
  },

  async publishLocalVideo (type, client, user, id, config) {
    let rtc
    if (type === Global.MediaSource.MediaSAgora) {
      rtc = AgoraRTC
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      rtc = LeiaRTC
    }

    try {
      user.videoTrack = await rtc.createCameraVideoTrack(config)
      user.videoTrack.play(`video-player-${id}`, Global.AGORA_VIDEO_CONFIG)
      await client.publish(user.videoTrack)
    } catch (err) {
      console.error('发布本地视频失败', err)
      return Promise.reject()
    }
  },

  toggleLocalScreenSharing (type, client, on, user, config) {
    if (!client) return Promise.reject(new Error(i18n.tc('rtc.RTCClientNotExist')))
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      if (on) {
        return this.publishLocalScreen(type, client, user, config)
      } else {
        return this.unPublishLocalMedia(client, user.videoTrack).then(() => {
          user.videoTrack = null
        })
      }
    } else return Promise.reject(new Error(i18n.tc('rtc.WebOnlySupportRTC')))
  },

  async publishLocalScreen (type, client, user, config) {
    let rtc
    if (type === Global.MediaSource.MediaSAgora) {
      rtc = AgoraRTC
    } else if (type === Global.MediaSource.MediaSLeiartc) {
      rtc = LeiaRTC
    }

    try {
      user.videoTrack = await rtc.createScreenVideoTrack(config)
      await client.publish(user.videoTrack)
    } catch (err) {
      console.error('发布本地屏幕共享失败', err)
      return Promise.reject(err)
    }
  },

  async unPublishLocalMedia (client, track) {
    if (!track) return Promise.resolve()
    try {
      await client.unpublish(track)
      track && track.close()
    } catch (err) {
      console.error('取消发布本地媒体失败', err)
      return Promise.reject()
    }
  },

  async toggleMute (track, on) {
    if (!track) return Promise.resolve()
    try {
      await track.setMuted(!on)
    } catch (err) {
      console.error(`切换静音失败, State: ${on} `, err)
      return Promise.reject()
    }
  },

  toggleLocalSpeaker (type, on, audios) {
    if (type === Global.MediaSource.MediaSAgora || type === Global.MediaSource.MediaSLeiartc) {
      const volume = on ? 100 : 0
      audios.forEach(audio => audio?.setVolume(volume))
    }
  }
}
